import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { GroupName } from 'src/app/shared/enums/groups.enum';

import {
	GroupsListSummary,
	GROUP_LABELS,
} from '../../../models/organizations.model';

@Component({
	selector: 'app-org-group-modal',
	styles: [
		`
			.item {
				height: 40px;
				border: 1px solid #d9d9d9;
				&:hover {
					background-color: #f0f0f0;
				}
			}
			.gray {
				color: #626262;
			}
			.separator {
				width: calc(100% - 32px);
				height: 1px;
				margin: 16px 0 16px 16px;
				background-color: #d9d9d9;
			}
			.mb-fix {
				margin-bottom: 84px;
			}
			@media only screen and (max-width: 768px) {
				/* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
				:host::ng-deep.mat-checkbox-layout {
					white-space: normal !important;
				}
				/* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
				:host::ng-deep.mat-checkbox-inner-container {
					margin-top: 4px;
				}
			}
		`,
	],
	templateUrl: './org-group-modal.component.html',
})
export class OrgGroupModalComponent implements OnInit {
	resultIds: string[] = [];

	constructor(
		public dialogRef: MatDialogRef<OrgGroupModalComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			disabled?: string;
			groups: GroupsListSummary[];
			isPartner: boolean;
			isSanus: boolean;
			selected: string[];
		},
	) {}

	closeModal() {
		this.dialogRef.close();
	}

	disableAllButOperator(g: string): boolean {
		return (
			this.data.isPartner &&
			this.data.isSanus &&
			g !== GroupName.OPERADOR &&
			g !== GroupName.BENEFICIARIO
		);
	}

	getGroupLabel(name: string): string {
		return GROUP_LABELS.find((o) => o.name === name)!.label;
	}

	ngOnInit(): void {
		this.resultIds = this.data.selected;
		if (this.data.isPartner && this.data.isSanus) {
			this.removeSelectedGroups();
		}
	}

	onCheckboxToggle(id: string, checked: boolean): void {
		if (!checked) {
			const index = this.resultIds.findIndex((i) => id === i);

			if (index >= 0) {
				this.resultIds.splice(index, 1);
			}
		} else {
			this.resultIds.push(id);
		}
	}

	/**
	 * Remove from selection (keeps: OPERADOR, BENEFICIARIO)
	 */
	removeSelectedGroups(): void {
		for (const group of this.data.groups) {
			if (
				group.name === GroupName.OPERADOR ||
				group.name === GroupName.BENEFICIARIO
			) {
				if (!this.data.selected.includes(group.id)) {
					this.onCheckboxToggle(group.id, true);
				}
			} else {
				if (this.data.selected.includes(group.id)) {
					this.onCheckboxToggle(group.id, false);
				}
			}
		}
	}

	saveItems(): void {
		const result = this.data.groups.filter((p) =>
			this.resultIds.includes(p.id),
		);
		this.dialogRef.close(result);
	}
}
